module.exports = __webpack_public_path__ + "img/Resume_Color.0adf3810.jpg";